<template>
  <div class="documents-keywords-summary">
    <BaseCircularLoadingBar v-if="documentKwPending || pending" :size="32" />
    <div v-else-if="hasNoPdfDocument" class="documents-keywords-summary__empty">
      {{ $t('page.opportunity-details.no-pdf-document-message') }}
    </div>
    <div v-else-if="hasScheduledKeywordIndexing">
      <OpportunityDocumentsQueueState />
    </div>
    <div v-else-if="hasNoResults" class="documents-keywords-summary__empty">
      {{ $t('page.analysis.keyword-navigator.no-keyword-found') }}
    </div>
    <div v-else>
      <div class="documents-keywords-summaryr__category" v-for="(category, index) in matchInformation" :key="index">
        <div class="documents-keywords-summary__category--item" v-if="category.results.length">
          <div class="documents-keywords-summary__kw-category--title">
            <div
              class="documents-keywords-summary__kw-category-color"
              :style="{ background: category.colorCode }"
            ></div>
            <div class="documents-keywords-summary__kw-category-name">{{ category.name }}</div>
            <div class="documents-keywords-summary__kw-category-occurrence">{{ categoryLength(category) }}</div>
          </div>
          <div class="documents-keywords-summary__category--content">
            <div class="documents-keywords-summary__kw-wrapper">
              <div
                v-for="(result, index) in category.results"
                :key="index"
                class="documents-keywords-summary__kw-category-items"
              >
                <div class="documents-keywords-summary__kw-category-items--description">
                  <span
                    class="documents-keywords-summary__kw-category-items--name"
                    v-tooltip="{
                      content: result.keyword.value,
                      delay: 400,
                    }"
                    >{{ result.keyword.value }}</span
                  >
                  <span class="documents-keywords-summary__kw-category-items--length" ref="keywordCount">
                    {{ result.occurrences }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCircularLoadingBar from '@/components/base/BaseCircularLoadingBar.vue';

import { mapGetters } from 'vuex';
import { isXlsFile } from '@/util/document-file-util';
import OpportunityDocumentsQueueState from '@/components/page-opportunity-details/OpportunityDocumentsQueueState.vue';

export default {
  name: 'DocumentsKeywordsSummary',
  components: {
    OpportunityDocumentsQueueState,
    BaseCircularLoadingBar,
  },
  computed: {
    ...mapGetters('opportunity', ['opportunity']),
    ...mapGetters('opportunityDocumentsPdfEngine', ['matchInformation', 'pending', 'error']),
    ...mapGetters('documentKeywords', { documentKwPending: 'pending' }),
    ...mapGetters('opportunityDocumentsQueue', ['hasScheduledKeywordIndexing']),
    hasNoResults() {
      return this.matchInformation.every((category) => category.results.length === 0);
    },
    hasNoPdfDocument() {
      return !this.hasPDFDocument;
    },
    hasDocuments() {
      return this.opportunity && this.opportunity.documents && this.opportunity.documents.length > 0;
    },
    hasPDFDocument() {
      return this.hasDocuments && this.opportunity.documents.find((document) => !isXlsFile(document));
    },
  },
  methods: {
    categoryLength(category) {
      return category.results.length > 0 ? '(' + category.results.length + ')' : '';
    },
  },
};
</script>

<style lang="scss">
.documents-keywords-summary {
  &__empty {
    color: $color-neutral;
  }

  &__category {
    &--item {
      border-radius: 8px;
      padding: 8px;
      margin-bottom: 8px;
    }
  }

  &__kw-category {
    &--title {
      font-weight: bold;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    &-color {
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }

  &__kw-wrapper {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding-top: 8px;
  }

  &__kw-category-items {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
    border-radius: 5px;
    padding: 4px 8px;
    margin: 2px 0;
    font-size: 14px;
    white-space: nowrap;
    background: $color-neutral-pale;
    width: min-content;
    &--description {
      display: flex;
      max-width: 280px;
    }
    &--length {
      font-weight: 300;
      color: $color-bluey-gray;
      margin-left: 8px;
      white-space: nowrap;
    }
  }
}
</style>
